export enum CatalogsApiEnum {
  GetTimeZoneList = '/catalogs/time-zones/',
  GetSubTaskTemplateList = '/catalogs/templates/',
  GetUserStatusList = '/catalogs/statuses/',
  GetLocations = '/catalogs/locations/',
}
